import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function UserManager() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/users", { params: q ? { q } : {} }).then(({ data }) => setUsers(data)).catch(() => {});
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [q]);

  return (
    <div data-testid="admin-users">
      <h1 className="font-serif text-4xl text-brand-green mb-6">Kullanıcılar</h1>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="İsim veya e-posta ara" data-testid="user-search" className="w-full max-w-sm mb-6 border border-brand-gold-light/50 rounded px-3 py-2 text-sm bg-white" />
      <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-cream text-brand-green text-left"><tr><th className="p-3">İsim</th><th className="p-3">E-posta</th><th className="p-3">Tip</th><th className="p-3">Rol</th><th className="p-3">Doğrulandı</th><th className="p-3">Kayıt</th></tr></thead>
          <tbody>{users.map((u) => (
            <tr key={u.id} className="border-t border-brand-gold-light/30">
              <td className="p-3 font-medium text-brand-green">{u.name}</td>
              <td className="p-3 text-brand-text/70">{u.email}</td>
              <td className="p-3 text-brand-text/60">{u.user_type || "-"}</td>
              <td className="p-3"><span className="text-xs bg-brand-cream px-2 py-1 rounded">{u.role}</span></td>
              <td className="p-3">{u.email_verified ? "✓" : "-"}</td>
              <td className="p-3 text-brand-text/50 text-xs">{(u.created_at || "").slice(0, 10)}</td>
            </tr>))}
          </tbody>
        </table>
        {users.length === 0 && <p className="p-6 text-brand-text/50 text-sm">Kullanıcı yok.</p>}
      </div>
    </div>
  );
}
